import { IColumn } from 'core-components/library/list/types'

export const IGNORED_FIELDS = ['EntryID']

export const COLUMNS: IColumn[] = [
  { field: 'ContactID', title: 'Contact ID', priority: 1 },
  { field: 'LearnerID', title: 'Learner ID', priority: 2 },
  { field: 'FirstName', title: 'First Name', priority: 3 },
  { field: 'LastName', title: 'Last Name', priority: 4 },
  {
    field: 'PR_HP_ROLE',
    title: 'Hp Roles',
    priority: 5,
  },
  {
    field: 'UserStatus',
    title: 'User Status',
    priority: 6,
  },
  {
    field: 'WorkPhone',
    title: 'Work Phone',
    priority: 7,
  },
  {
    field: 'MobilePhone',
    title: 'Mobile Phone',
    priority: 8,
  },
  { field: 'Email', title: 'Email', priority: 9 },
  {
    field: 'LocationID',
    title: 'Location ID',
    priority: 10,
  },
  {
    field: 'NeverCall',
    title: 'Never Call',
    priority: 11,
  },
  {
    field: 'NeverEmail',
    title: 'Never Email',
    priority: 12,
  },
  {
    field: 'PartnerID',
    title: 'Partner ID',
    priority: 13,
  },
  {
    field: 'CommunicationName',
    title: 'Comm. Name',
    priority: 14,
  },
  { field: 'City', title: 'City', priority: 15 },
  {
    field: 'PrimaryPartner',
    title: 'Primary',
    priority: 16,
  },
]

export const COLUMNS_PARTNER360: IColumn[] = [
  { field: 'ContactID', title: 'Contact ID', priority: 1 },
  { field: 'FirstName', title: 'First Name', priority: 2 },
  { field: 'LastName', title: 'Last Name', priority: 3 },
  { field: 'Email', title: 'Email', priority: 4 },
  { field: 'PR_HP_ROLE', title: 'Hp Roles', priority: 5 },
  { field: 'PrimaryPartner', title: 'Primary', priority: 6 },
]
